import React from "react";
import Footer from "../components/Footer/Footer";
import "./Page.css";

function Support() {
  return (
    <div className="page-container">
      <div className="content-card">
        <h1 className="page-title">Support & Contact</h1>
        
        <div className="page-content">
          <p className="intro-text">We're here to help.</p>

          <p>
            If you have any questions, need assistance, or would like to report an issue related to any of our applications or services, please reach out to us through the following official support channels. Our team is committed to providing timely and precise assistance.
          </p>

          <div className="info-section">
            <h2>Support Email</h2>
            <p>
              <a href="mailto:support@thesixteenthdegree.com">
                support@thesixteenthdegree.com
              </a>
            </p>
          </div>

          <div className="info-section">
            <h2>General Inquiries</h2>
            <p>
              <a href="mailto:baig@thesixteenthdegree.com">
                baig@thesixteenthdegree.com
              </a>
            </p>
          </div>

          
          <div className="info-section">
            <h2>For Product-Specific Issues</h2>
            <p>To help us assist you more effectively, please include:</p>
            <ul>
              <li>The name of the app</li>
              <li>Your device type (iOS/Android)</li>
              <li>A brief description of the issue</li>
              <li>Screenshots (if applicable)</li>
            </ul>
          </div>

          <p className="feedback-text">
            Your feedback helps us improve our products and deliver better experiences to our users.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Support;

